import { forwardRef, type HTMLAttributes } from 'react';
import { X } from 'lucide-react';
import { cn } from '../utils/cn.js';

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  onRemove?: () => void;
  tone?: 'default' | 'info' | 'success' | 'warning' | 'danger';
}

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(function Chip(
  { onRemove, tone = 'default', className, children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn('chip', tone !== 'default' && `chip-${tone}`, className)}
      data-tone={tone}
      {...rest}
    >
      <span>{children}</span>
      {onRemove ? (
        <button
          type="button"
          className="chip-x"
          aria-label="Remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <X size={12} aria-hidden />
        </button>
      ) : null}
    </span>
  );
});
